/**
 * Textos principais — blocos curtos, tom confiança + clareza.
 */

export const CITACAO = {
  text: 'Reduzir estresse não é luxo — é investir em quem sustenta a cidade.',
  attribution: 'Lunins',
} as const;

export const SITE = {
  title: 'Lunins — Bem-estar institucional e loja oficial',
  tagline: 'Bem-estar com lastro institucional e atendimento humano.',
  footerInstitutionalLine: 'Projetos institucionais de descompressão e loja oficial de equipamentos Lunins.',
  siteInstitucionalUrl: 'https://www.lunins.org',
  org: {
    razao: 'L.D.Z Arquitetura Bem Estar LTDA',
    cnpj: '63.105.156/0001-57',
    instagram: '@luninsbr',
    email: 'comunicacao@lunins.org',
    whatsappDisplay: '(67) 99208-9769',
  },
} as const;

export const HERO = {
  eyebrow: 'Salas de descompressão · Equipamentos · MS',
  headline: 'O cuidado que transforma instituições também chega à sua rotina.',
  sub: 'Salas no setor público; esta loja leva a mesma curadoria aos equipamentos para casa.',
  ctaPrimary: 'Explorar equipamentos',
  ctaSecondary: 'Institucional',
  ctaSecondaryHref: 'https://www.lunins.org',
} as const;

export const PILARES = {
  title: 'Uma marca, duas frentes claras',
  subtitle: 'Em lunins.org, o contexto institucional. Aqui, a vitrine oficial com equipamentos e atendimento comercial da mesma marca.',
  cards: [
    {
      title: 'Instituições',
      body: 'Salas, ações e projetos com foco em bem-estar no ambiente de trabalho.',
    },
    {
      title: 'Loja',
      body: 'Equipamentos alinhados ao que a Lunins recomenda em campo, com catálogo aberto e fechamento pela equipe.',
    },
  ],
} as const;

export const DIFERENCIAIS = {
  title: 'O que sustenta a marca',
  items: [
    {
      t: 'Operação real em campo',
      d: 'A Lunins já atua com salas, ações e projetos de descompressão em instituições e empresas.',
    },
    {
      t: 'Canais e identificação oficiais',
      d: 'Razão social, CNPJ, e-mail, WhatsApp e lunins.org aparecem de forma consistente em toda a jornada.',
    },
    {
      t: 'Curadoria conectada',
      d: 'A loja não é uma vitrine genérica: ela traduz em produtos o repertório que a marca leva para o campo.',
    },
  ],
} as const;

export const LOGISTICA = {
  title: 'Entrega e condições',
  lines: [
    'Prazo, frete e parcelamento: sempre alinhados com a equipe após o fechamento (região e campanha vigente).',
    'Frete grátis apenas quando estiver explícito na oferta (ex.: mesma cidade em campanha).',
    'Pagamento sensível só por orientação oficial Lunins (link, PIX ou outra forma combinada).',
  ],
} as const;

export const NUMEROS = {
  title: 'Lastro operacional',
  stats: [
    { value: '90+', label: 'Projetos em instituições (referência histórica)' },
    { value: 'MS', label: 'Atuação em Campo Grande e interior' },
    { value: '3', label: 'Etapas típicas: diagnóstico, implantação e acompanhamento' },
  ],
  disclaimer:
    'Números de referência operacional; não substituem métricas auditáveis externas. Atualização conforme acompanhamento interno.',
} as const;

/** Micro-cards do hero da home — uma única fonte de texto */
export const HERO_MICRO_CARDS = [
  {
    t: 'Entrega e prazo',
    s: 'Definidos com a equipe após o fechamento (região e campanha).',
  },
  {
    t: 'Frete',
    s: 'Grátis só quando a oferta disser (ex.: mesma cidade).',
  },
  {
    t: 'Atendimento',
    s: 'WhatsApp oficial — equipe comercial Lunins.',
  },
] as const;

export const LOJA_PAGE = {
  title: 'Catálogo Lunins',
  subtitle:
    'Preços de referência na vitrine; valor final, parcelas e entrega no WhatsApp com a equipe.',
} as const;

export const CATALOGO_HOME = {
  title: 'Equipamentos em destaque',
  subtitle: 'A mesma marca que atua em campo reúne aqui a vitrine oficial para comparar produtos e iniciar o fechamento.',
} as const;

export const CTA_FINAL = {
  title: 'Quer continuar pelo catálogo?',
  body: 'Abra a loja oficial para comparar equipamentos, entender a linha Lunins e falar com a equipe quando fizer sentido.',
  button: 'Abrir loja oficial',
} as const;

export const COMO_COMPRAR_CTA_LOJA = 'Ir para a loja' as const;

/** Rodapé — evita repetir a mesma ideia do bloco de logística */
export const FOOTER_SITE = {
  diferencaCanais: 'lunins.org concentra o contexto institucional; este domínio é o canal oficial para as pausas no dia a dia.',
  entregaResumo:
    'Prazo e frete combinados com a equipe após o fechamento, conforme região e campanha.',
} as const;
